import { createSliceDefinitions } from 'store/helpers/createSliceDefinitions';
import type { SliceCreator } from 'store/useAppStore.types';
import type { ChatWidgetSlice, ChatWidgetSliceState } from './chatWidget.types';

const { actions } = createSliceDefinitions('ChatWidgetSlice', {
  SET_WINDOW_VISIBILITY: 'setWindowVisibility',
  SET_IS_INITIALIZED: 'setIsInitialized',
  RESET: 'reset',
});

const initialState: ChatWidgetSliceState = {
  isChatWidgetWindowVisible: false,
  isInitialized: false,
};

export const createChatWidgetSlice: SliceCreator<ChatWidgetSlice> = (set) => ({
  ...initialState,

  actions: {
    setWindowVisibility: (isChatWidgetWindowVisible) => {
      set(
        (state) => {
          state.chatWidget.isChatWidgetWindowVisible = isChatWidgetWindowVisible;
        },
        false,
        { type: actions.SET_WINDOW_VISIBILITY, payload: isChatWidgetWindowVisible },
      );
    },
    setIsInitialized: () => {
      set(
        (state) => {
          state.chatWidget.isInitialized = true;
        },
        false,
        actions.SET_IS_INITIALIZED,
      );
    },
    reset: () => {
      set(
        (state) => {
          state.chatWidget = {
            ...state.chatWidget,
            ...initialState,
          };
        },
        false,
        actions.RESET,
      );
    },
  },
});
